export { mapAllowedModulesToPermissionModules } from './allowed-modules.utils'
